import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 14\" id=\"close\">\r\n<g>\r\n\t<path d=\"M0.2,1.2c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,0.7-0.3,1,0L7,6l5.8-5.8c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1L8,7l5.8,5.8\r\n\t\tc0.3,0.3,0.3,0.7,0,1c-0.3,0.3-0.7,0.3-1,0L7,8l-5.8,5.8c-0.3,0.3-0.7,0.3-1,0c-0.3-0.3-0.3-0.7,0-1L6,7L0.2,1.2z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol